import type { MouseEvent } from 'react'
import { formatServiceLineLabel } from '@/utils/text-normalization'
import { DraggableElement } from './DraggableElement'
import type { SlideCategoryBlock } from './computeSlideCategoryBlocks'
import { SLIDE_GREEN_ACCENT } from './slidePreviewTheme'

type SlideScopeBlocksProps = {
  blocks: SlideCategoryBlock[]
  compact: boolean
  categoryTitleSize: string
  itemFontSize: string
  checkFontSize: string
  draggingKey: string | null
  blockNumbers: Map<string, number>
  onDragStart: (e: MouseEvent, key: string) => void
}

export function SlideScopeBlocks({
  blocks,
  compact,
  categoryTitleSize,
  itemFontSize,
  checkFontSize,
  draggingKey,
  blockNumbers,
  onDragStart,
}: SlideScopeBlocksProps) {
  return (
    <>
      {blocks.map((block) => (
        <DraggableElement
          key={block.categoria}
          x={block.x}
          y={block.y}
          width={`${block.widthPercent}%`}
          dragging={draggingKey === `category_${block.categoria}`}
          onMouseDown={(e) => onDragStart(e, `category_${block.categoria}`)}
          blockNumber={blockNumbers.get(block.categoria)}
        >
          <div
            className={`rounded-lg border border-white/10 bg-white/[0.035] shadow-[0_0_18px_rgba(124,58,237,0.12)] ${
              compact ? 'px-1.5 py-1' : 'p-2'
            }`}
          >
            <div
              style={{
                color: '#ffffff',
                fontSize: categoryTitleSize,
                fontWeight: 800,
                fontFamily: 'Arial, sans-serif',
                lineHeight: 1.2,
                borderBottom: '1px solid rgba(255,47,134,0.55)',
                paddingBottom: compact ? 4 : 5,
                marginBottom: compact ? 3 : 4,
              }}
            >
              {block.categoria}
            </div>
            {block.items.map((item) => {
              const checkColor = item.isPartial ? '#f59e0b' : SLIDE_GREEN_ACCENT
              const checkChar = item.isPartial ? '◑' : '✓'
              const lineLabel = formatServiceLineLabel(item.nome, item.quantity)
              return (
                <div
                  key={item.id}
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: compact ? 2 : 4,
                    marginTop: compact ? 1 : 2,
                  }}
                >
                  <span style={{ color: checkColor, fontSize: checkFontSize, fontWeight: 'bold', flexShrink: 0 }}>
                    {checkChar}
                  </span>
                  <span
                    style={{
                      color: '#d7d9e8',
                      fontSize: itemFontSize,
                      fontFamily: 'Arial, sans-serif',
                      lineHeight: compact ? 1.2 : 1.35,
                    }}
                  >
                    {lineLabel}
                  </span>
                </div>
              )
            })}
          </div>
        </DraggableElement>
      ))}
    </>
  )
}
